module.exports = __webpack_public_path__ + "img/btnCard-2-m.bc5d0ce1.jpg";